export default __webpack_public_path__ + "static/media/upi-logo.2e0bd454.png";